import { render, staticRenderFns } from "./UsaL1.vue?vue&type=template&id=a8bc7828&scoped=true&"
import script from "./UsaL1.vue?vue&type=script&lang=js&"
export * from "./UsaL1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bc7828",
  null
  
)

export default component.exports